export default "__VITE_ASSET__ByVjdZZF__"